import { IUser } from '../types/users'
import { IService } from '../types/services'
import { AxiosClient, AxiosToken } from '../config/axios'

/**
 * This method is used to connect with backend and get service by id
 * @param {String} id
 * @return {IService} IService
*/
export const getService = async (id: any): Promise<any> => {
  try
  {
    const token = localStorage.getItem('token')
    if (token) {
      AxiosToken(token)
    }
    const response: IService = await AxiosClient.get(`/service?id=${id}`)
    return { data: response }
  } catch (error:any) {
    return { error: error.res.data.message }
  }
}

/**
 * This method is used to connect with backend and get list of services
 * @return {Array} services
*/
export const getServices = async (): Promise<any> => {
  try {
    const token = localStorage.getItem('token')
    if (token) {
      AxiosToken(token)
    }
    const response = await AxiosClient.get('/service/list')
    return { data: response.data }
  } catch (error:any) {
    return { error: error.response.data.message }
  }
}

/**
 * This method is used to connect with backend and get list of services share
 * @return {Array} services share
*/
export const getServicesShare = async (email: any): Promise<any> => {
  try {
    const token = localStorage.getItem('token')
    if (token) {
      AxiosToken(token)
    }
    const response = await AxiosClient.get(`/service/listShare?email=${email}`)
    return { data: response.data }
  } catch (error:any) {
    return { error: error.response.data.message }
  }
}

/**
 * This method is used to connect with backend and get list of services by user
 * @param {String} data name or email
 * @return {Array} services share
*/
export const getServicesUser = async (data: any): Promise<any> => {
  try
  {  
    let response: IUser;
    response = (await AxiosClient.get(`user/user_name?user_name=${data}`)).data
    if(!response){
      response = (await AxiosClient.get(`user/email?email=${data}`)).data
    }
    if(!response){
      return;
    }
    const token = localStorage.getItem('token')
    if (token) {
      AxiosToken(token)
    }
    const res = await AxiosClient.get('/service/documents-user', {params: {dataUser: response.id}})
    return { data: res.data }
  }
  catch (error:any) 
  {
    return { error: error.res.data.message }
  }
}

/**
 * This method is used to connect with backend and save service
 * @param {Object} data
 * @return {Object} message and data: service
*/
export const saveService = async (data: any): Promise<any> => {
  try {
    const token = localStorage.getItem('token')
    if (token) {
      AxiosToken(token)
    }
    const response = await AxiosClient.post('/service', data)
    return { data: response.data }
  } catch (error:any) {
    return { error: error.response.data.message }
  }
}

/**
 * This method is used to connect with backend and update service
 * @param {Object} data
 * @return {Object} message and data: service
*/
export const updateService = async (data: any): Promise<any> => {
  try {
    const token = localStorage.getItem('token')
    if (token) {
      AxiosToken(token)
    }
    const response = await AxiosClient.put('/service', data)
    return { data: response.data }
  } catch (error:any) {
    return { error: error.response.data.message }
  }
}

/**
 * This method is used to connect with backend and delete service
 * @param {Object} data
 * @return {String} message
*/
export const deleteService = async (data: any): Promise<any> => {
  try {
    const token = localStorage.getItem('token')
    if (token) {
      AxiosToken(token)
    }
    const response = await AxiosClient.delete('/service', {data})
    return { data: response.data }
  } catch (error:any) {
    return { error: error.response.data.message }
  }
}